/* global axios */
import ApiClient from '../ApiClient';

class InstagramChannel extends ApiClient {
  constructor() {
    super('instagram', { accountScoped: true });
  }

  generateAuthorization(payload) {
    console.log('InstagramChannel.generateAuthorization', payload);
    console.log('url', this.url);
    return axios.post(`${this.url}/authorization`, payload);
  }
}

export default new InstagramChannel();
